import { configAxios } from './apiConfig';
import { createLog } from './logService';

export const verifyIfItsValid = async (email) => {
  try {
    const response = await configAxios.get(`email?email=${email}`);

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};
